export const FORM_TYPE_TRANSLATIONS = {
  coi: 'form_types.coi',
  gnd: 'form_types.gnd',
  unknown: 'form_types.unknown',
} as const;

export const COI_CATEGORY_TRANSLATIONS = {
  relationship: 'coi.categories.relationship',
  personalInvestment: 'coi.categories.personal_investment',
  otherOccupation: 'coi.categories.other_occupation',
} as const;

export const GND_CATEGORY_TRANSLATIONS = {
  youAreGiving: 'gnd.categories.you_are_giving',
  youAreReceiving: 'gnd.categories.you_are_receiving',
  officeInternalUsage: 'gnd.categories.office_internal_usage',
} as const;

export const GND_SUBCATEGORY_TRANSLATIONS = {
  giftOrHospitality: 'gnd.subcategories.gift_or_hospitality',
  donation: 'gnd.subcategories.donation',
  sponsorship: 'gnd.subcategories.sponsorship',
  politicalContribution: 'gnd.subcategories.political_contribution',
} as const;

export const SPECIFIC_FIELD_TRANSLATIONS = {
  // COI Fields
  otherPartyInvolved: 'coi.fields.other_party_involved',
  relationshipType: 'coi.fields.relationship_type',
  
  // GND Fields
  typeOfRecipient: 'gnd.fields.type_of_recipient',
  typeOfProvider: 'gnd.fields.type_of_provider',
  typeOfGift: 'gnd.fields.type_of_gift',
  totalAmountInUsd: 'gnd.fields.total_amount_in_usd',
  
  // Section Headers
  coiDetailsSection: 'coi.sections.details',
  gndDetailsSection: 'gnd.sections.details',
  otherPartySection: 'coi.sections.other_party',
} as const;
